import IUser from "../../models/IUser";
import React from "react";
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Typography,
    Backdrop,
    Fade,
    Button,
    Paper,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import Loading from "../shared/Loading";
import TableStyle from "../shared/Styling/TableStyling";
import SettingsIcon from "@material-ui/icons/Settings";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
interface IUsersTable {
    users: IUser[] | null;
    isLoading: boolean;
    onRemoveUser(userId: string): void;
    onUpdateProfile(user: IUser): void;
    onUpdatePreferences(user: IUser): void;
    isProcessing: boolean;
}

const UsersTable: React.FC<IUsersTable> = ({
    users,
    isLoading,
    onRemoveUser,
    onUpdateProfile: OnUpdateProfile,
    onUpdatePreferences: OnUpdatePreferences,
    isProcessing
}) => {
    const classes = TableStyle();

    const [openModal, setModal] = React.useState(false);
    const [modalUser, setModalUser] = React.useState(null as IUser | null);

    const handleOpenDeleteConfirmation = (user: IUser) => {
        setModalUser(user);
        setModal(true);
    };

    const handleUpdateProfile = (user: IUser) => {
        OnUpdateProfile(user);
    };

    const handleUpdatPreferences = (user: IUser) => {
        OnUpdatePreferences(user);
    };

    const handleCloseDeleteConfirmation = () => {
        setModalUser(null);
        setModal(false);
    };

    return (
        <div className={classes.root}>
            <Table className={classes.table}>
                <TableHead className={classes.header}>
                    <TableRow>
                        <TableCell className={classes.headerCell}>
                            Name
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                            E-Mail
                        </TableCell>
                        <TableCell className={classes.headerCell}>
                            Phone Number
                        </TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {isLoading || users === null ? (
                        <>
                            <div
                                style={{
                                    position: "absolute",
                                    left: "45%",
                                    top: "80px"
                                }}
                            >
                                <Loading />
                            </div>
                        </>
                    ) : users.length === 0 ? (
                        <TableRow className={classes.row}>
                            <TableCell
                                colSpan={4}
                                className={classes.headerCell}
                                style={{ width: "30rem" }}
                            >
                                <Typography
                                    variant="subtitle2"
                                    className={classes.message}
                                >
                                    <cite>
                                        There are currently no users associated
                                        with this project. Please use the button
                                        above to add a user.
                                    </cite>
                                </Typography>
                            </TableCell>
                        </TableRow>
                    ) : (
                        users!.map(user => (
                            <TableRow key={user.email} className={classes.row}>
                                <TableCell component="th" scope="row">
                                    {user.firstName} {user.lastName}
                                </TableCell>
                                <TableCell>{user.email}</TableCell>
                                <TableCell>{user.phoneNumber}</TableCell>
                                <TableCell>
                                    {isProcessing === false ? (
                                        <>
                                            <AccountCircleIcon
                                                aria-label="profile"
                                                onClick={() =>
                                                    handleUpdateProfile(user)
                                                }
                                                className={classes.button}
                                            />
                                            <SettingsIcon
                                                aria-label="preferences"
                                                onClick={() =>
                                                    handleUpdatPreferences(user)
                                                }
                                                className={classes.button}
                                            />
                                            <DeleteIcon
                                                aria-label="delete"
                                                onClick={() =>
                                                    handleOpenDeleteConfirmation(
                                                        user
                                                    )
                                                }
                                                className={classes.button}
                                            />
                                        </>
                                    ) : (
                                        <Loading immediate={true} />
                                    )}
                                </TableCell>
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
            <Dialog
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={openModal}
                onClose={handleCloseDeleteConfirmation}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500
                }}
            >
                <Fade in={openModal}>
                    <Paper className={classes.paper}>
                        <DialogTitle>
                            <Typography
                                id="transition-modal-title"
                                variant="h2"
                            >
                                Remove User
                            </Typography>
                        </DialogTitle>
                        <DialogContent>
                            <Typography
                                id="transition-modal-description"
                                variant="subtitle2"
                            >
                                Are you sure you would like to remove{" "}
                                {modalUser && modalUser.email} from this
                                project?
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                color="primary"
                                onClick={() => {
                                    if (modalUser !== null) {
                                        onRemoveUser(modalUser!.id);
                                    }
                                    handleCloseDeleteConfirmation();
                                }}
                            >
                                Delete
                            </Button>
                            <Button
                                color="primary"
                                onClick={handleCloseDeleteConfirmation}
                            >
                                Cancel
                            </Button>
                        </DialogActions>
                    </Paper>
                </Fade>
            </Dialog>
        </div>
    );
};

export default UsersTable;
